export const AccordionHeaderParamsTexts = {
  HeaderDefaultTitle: 'Контакты',
  HeaderDefaultDescription: 'Заполните данные',
};
